import {
  FETCH_SCHEDULED,
  FETCH_SCHEDULED_SUCCESS,
  FETCH_SCHEDULED_FAILURE,
  UPDATE_SCHEDULED_PAYMENT,
  UPDATE_SCHEDULED_PAYMENT_SUCCESS,
  UPDATE_SCHEDULED_PAYMENT_FAILURE,
  CANCEL_SCHEDULED_PAYMENT,
  CANCEL_SCHEDULED_PAYMENT_SUCCESS,
  CANCEL_SCHEDULED_PAYMENT_FAILURE,
  RESET_ERRORS,
} from '../actions/scheduledPayments';

import {
  RESET_PAYMENT,
} from '../actions/payment';

const INITIAL_STATE = {
  loading: true,
  cached: false,
  payments: [],
};

export default function scheduledPaymentsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CANCEL_SCHEDULED_PAYMENT:
    case UPDATE_SCHEDULED_PAYMENT:
      return {
        ...state,
        submitting: true,
        submitError: null,
        confirm: null,
      };
    case UPDATE_SCHEDULED_PAYMENT_SUCCESS:
      return {
        ...state,
        confirm: action.payload,
        submitting: false,
        payments: state.payments.map((payment) => {
          if (payment.id === action.payload.payment_id) {
            return {
              ...payment,
              amount: action.payload.amount,
              // Use the ISO schedule_date so the list renders the
              // correct day regardless of timezone.
              date: action.payload.schedule_date || action.payload.date,
            };
          }

          return payment;
        }),
      };
    case CANCEL_SCHEDULED_PAYMENT_SUCCESS:
      return {
        ...state,
        submitting: false,
        payments: state.payments.filter(payment => payment.id !== action.payload.payment_id),
      };
    case CANCEL_SCHEDULED_PAYMENT_FAILURE:
    case UPDATE_SCHEDULED_PAYMENT_FAILURE:
      return {
        ...state,
        submitError: action.payload,
        submitting: false,
      };
    case FETCH_SCHEDULED:
      return {
        ...state,
        loading: true,
        cached: true,
      };
    case FETCH_SCHEDULED_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        error: null,
      };
    case FETCH_SCHEDULED_FAILURE:
      return {
        ...state,
        loading: false,
        cached: false,
        error: action.payload,
      };
    case RESET_ERRORS:
      return {
        ...state,
        error: null,
      };
    case RESET_PAYMENT:
      return {
        ...state,
        review: null,
        confirm: null,
      };
    default:
      return state;
  }
}
